import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/terms")({
  component: TermsOfServicePage,
});

function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Nutzungsbedingungen
        </h1>
        <p className="text-gray-500 mb-8">Version: 12.03.2026</p>

        <div className="prose prose-gray max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 1 Anbieter und Geltungsbereich
            </h2>
            <p className="mb-4">
              Anbieter dieser Dienste ist die Ivelion Health GmbH,
              Altensteinstraße 40, 14195 Berlin, Deutschland (nachfolgend
              „Anbieter"). Diese Bedingungen regeln die Nutzung der webbasierten
              Ivelion AI Plattform einschließlich des MS-Chatbots (nachfolgend
              „Software").
            </p>
            <p className="mb-4">
              Abweichende Geschäftsbedingungen gelten nicht, es sei denn, der
              Anbieter stimmt schriftlich zu.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 2 Vertragsgegenstand
            </h2>
            <p className="mb-4">
              Der Anbieter stellt die jeweils aktuelle Version der Software über
              das Internet zur Nutzung bereit. Der Zugriff erfolgt über einen
              gängigen Browser auf Desktop und Mobile. Eine physische
              Überlassung findet nicht statt.
            </p>
            <p className="mb-4">
              Die Software umfasst u. a. einen Chatbot für Informationen zu
              Multipler Sklerose und die Generierung von E-Mail-Entwürfen. Die
              Nutzung ist ohne Anmeldung (anonym) oder mit Konto möglich.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 3 Medizinischer Hinweis
            </h2>
            <p className="mb-4">
              Die Inhalte der Software stellen{" "}
              <strong>keinen medizinischen Rat</strong> dar. Sie ersetzen keine
              ärztliche Beratung, Diagnose oder Behandlung. Triff keine
              Gesundheitsentscheidungen allein auf Basis der Ausgaben der
              Software. In Notfällen rufe den Notruf 112 oder suche umgehend
              ärztliche Hilfe.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 4 Leistungen und Verfügbarkeit
            </h2>
            <p className="mb-4">
              (1) Der Anbieter bemüht sich um eine monatliche Verfügbarkeit von
              mindestens 95 %. Zeiten geplanter Wartung und unvorhersehbare
              Ereignisse (z. B. höhere Gewalt, Drittnetzstörungen) sind hiervon
              ausgenommen.
            </p>
            <p className="mb-4">
              (2) Funktionsumfang und Inhalte können weiterentwickelt, geändert
              oder eingestellt werden. Wesentliche Änderungen werden angemessen
              angekündigt.
            </p>
            <p className="mb-4">
              (3) Supportanfragen können per E-Mail an{" "}
              <a
                href="mailto:nils.zaenker@ivelion.com"
                className="text-purple-600 hover:text-purple-700"
              >
                nils.zaenker@ivelion.com
              </a>{" "}
              gestellt werden. Die Bearbeitung erfolgt nach Priorität und
              Eingang.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 5 Zulässige Nutzung
            </h2>
            <p className="mb-4">
              Du nutzt die Software nur im Rahmen geltenden Rechts. Untersagt
              sind insbesondere: rechtswidrige Inhalte, Belästigung, Spam, die
              Umgehung von Sicherheitsmechanismen, Reverse Engineering sowie
              automatisiertes Massenscraping ohne schriftliche Zustimmung.
            </p>
            <p className="mb-4">
              Du speicherst keine Inhalte, deren Rechte dir nicht zustehen oder
              die Rechte Dritter verletzen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 6 Registrierung und Konto
            </h2>
            <p className="mb-4">
              Für die anonyme Nutzung ist keine Registrierung erforderlich. Für
              ein Konto sind wahrheitsgemäße Angaben zu machen. Zugangsdaten
              sind geheim zu halten. Du bist für Handlungen über dein Konto
              verantwortlich.
            </p>
            <p className="mb-4">
              Mit Konto registrierte Nutzer können produktbezogene Mitteilungen
              erhalten. Jede E-Mail enthält einen Abmeldelink (Opt-out).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 7 Rechte an Inhalten; KI-Ausgaben
            </h2>
            <p className="mb-4">
              Eingaben und hochgeladene Inhalte („Nutzerinhalte") verbleiben bei
              dir. Du räumst dem Anbieter eine einfache, widerrufliche,
              weltweite Lizenz zur Verarbeitung der Nutzerinhalte zum Betrieb,
              zur Sicherheit und zur Verbesserung der Software ein.
            </p>
            <p className="mb-4">
              KI-Ausgaben können fehlerhaft, unvollständig oder veraltet sein.
              Prüfe die Ergebnisse vor eigener Nutzung, insbesondere vor
              Außenkommunikation oder Gesundheitsentscheidungen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 8 Vergütung
            </h2>
            <p className="mb-4">
              Der Dienst ist derzeit kostenfrei. Der Anbieter kann künftig
              entgeltliche Pläne einführen. Darüber wird vorab informiert; für
              bestehende Verträge gelten Änderungen erst nach Zustimmung des
              Nutzers.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 9 Gewährleistung und Haftung
            </h2>
            <p className="mb-4">
              (1) Der Anbieter leistet keine Gewähr für die Eignung der Software
              für einen bestimmten Zweck.
            </p>
            <p className="mb-4">
              (2) Der Anbieter haftet unbegrenzt für Vorsatz und grobe
              Fahrlässigkeit, für Schäden aus der Verletzung von Leben, Körper
              oder Gesundheit sowie nach dem Produkthaftungsgesetz.
            </p>
            <p className="mb-4">
              (3) Bei einfacher Fahrlässigkeit haftet der Anbieter nur bei
              Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) und
              beschränkt auf den vorhersehbaren, typischen Schaden. Eine Haftung
              für entgangenen Gewinn ist ausgeschlossen, es sei denn, es greift
              Abs. 2.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 10 Datenschutz und Vertraulichkeit
            </h2>
            <p className="mb-4">
              Für die Verarbeitung personenbezogener Daten gelten die{" "}
              <Link
                to="/privacy"
                className="text-purple-600 hover:text-purple-700"
              >
                Datenschutzhinweise
              </Link>
              . Vertrauliche Informationen werden nur insoweit verarbeitet, wie
              es für den Betrieb der Software erforderlich ist.
            </p>
            <p className="mb-4">
              Zur Verbesserung unserer Dienste und zur Analyse der geografischen
              Verteilung unserer Nutzer erfassen wir zu Beginn jeder
              Chat-Sitzung Ihre ungefähre Position basierend auf Ihrer
              IP-Adresse (Stadt, Bundesland und Koordinaten). Dies hilft uns,
              Sie mit nahegelegenen Studienzentren in Verbindung zu bringen. Die
              IP-Adresse selbst wird nicht gespeichert.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 11 Laufzeit und Kündigung
            </h2>
            <p className="mb-4">
              Da die Nutzung der Anwendung ohne Registrierung möglich ist und
              keine Vertragsbindung besteht, ist keine Kündigung erforderlich.
              Du kannst die Nutzung jederzeit beenden. Deine Daten werden
              für die Dauer der Nutzung und darüber hinaus zur
              Serviceverbesserung und zu Forschungszwecken gespeichert. Du
              kannst jederzeit die Löschung deiner Daten gemäß Art. 17 DSGVO
              per E-Mail an{" "}
              <a
                href="mailto:nils.zaenker@ivelion.com"
                className="text-purple-600 hover:text-purple-700"
              >
                nils.zaenker@ivelion.com
              </a>{" "}
              verlangen.
            </p>
            <p className="mb-4">
              Der Anbieter kann Zugänge sperren, wenn ein Verstoß gegen diese
              Bedingungen oder ein Missbrauch vorliegt.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 12 Minderjährige
            </h2>
            <p className="mb-4">
              Der Dienst richtet sich an Personen ab 16 Jahren. Jüngere Personen
              benötigen die Zustimmung der Erziehungsberechtigten.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 13 Änderungen der Bedingungen
            </h2>
            <p className="mb-4">
              Der Anbieter kann diese Bedingungen anpassen. Über wesentliche
              Änderungen wird in der Software informiert. Widersprichst du,
              musst du die Nutzung einstellen; setzt du die Nutzung fort, gilt
              dies als Zustimmung zur geänderten Fassung.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              § 14 Anwendbares Recht und Gerichtsstand
            </h2>
            <p className="mb-4">
              Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Ist
              der Nutzer Kaufmann, ist ausschließlicher Gerichtsstand der Sitz
              des Anbieters: Berlin.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              § 15 Kontakt
            </h2>
            <p className="mb-4">
              Ivelion Health GmbH <br /> E-Mail:{" "}
              <a
                href="mailto:nils.zaenker@ivelion.com"
                className="text-purple-600 hover:text-purple-700"
              >
                nils.zaenker@ivelion.com
              </a>{" "}
              <br /> Anschrift: Altensteinstraße 40, 14195 Berlin, Deutschland ·
              <br /> Register: HRB 281646 B <br /> Vertretung: Nils Zaenker.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 flex items-center justify-between">
          <Link
            to="/"
            className="text-purple-600 hover:text-purple-700 font-medium"
          >
            ← Zurück zum Chat
          </Link>
          <Link
            to="/privacy"
            className="text-purple-600 hover:text-purple-700 font-medium"
          >
            Datenschutzhinweise →
          </Link>
        </div>
      </div>
    </div>
  );
}
